import { Box, Button, Container, Stack, Text, Title } from '@mantine/core';
import { Link, useRouterState } from '@tanstack/react-router';
import { AppShell } from '../../app-shell';

export const RouteNotFoundState = () => {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });

  return (
    <AppShell>
      <Container size="md" py={100} px="xl">
        <Box>
          <Stack spacing="lg">
            <div>
              <Title order={2}>Page not found</Title>
              <Text mt="xs" c="dimmed">
                No route matches <code>{pathname}</code>. Check the URL or go
                back to the schema list.
              </Text>
            </div>

            <Button component={Link} to="/list">
              Go to schema list
            </Button>
          </Stack>
        </Box>
      </Container>
    </AppShell>
  );
};
